import { isEqual } from 'lodash-es';

import {
  type TransformedEditInSeasonAggregationRequest,
  type TransformedGetInSeasonAggregationsListRequest,
} from '../types';

export const findInSeasonQueryArgsToInvalidate = (
  inSeasonCachedQueryArgs: TransformedGetInSeasonAggregationsListRequest[],
  mutationInSeasonQueryArgs: TransformedEditInSeasonAggregationRequest,
) => {
  const { selection } = mutationInSeasonQueryArgs.body;

  if (selection.selection_type === 'include_list') {
    if (selection.include_list.length === 0) {
      return inSeasonCachedQueryArgs;
    }
    const mutationDimensions = selection.include_list[0];
    const mutationDimensionNames = mutationDimensions.map(
      (dimension) => dimension.dimension,
    );
    const { dimension_filters: mutationDimensionFilters } =
      selection?.filters ?? {};

    // filter out all cache entries that do not have the same product and location dimensions and dimension filters
    return inSeasonCachedQueryArgs.filter(({ body }) => {
      const {
        dimensions: queryDimensionNames,
        filters: { dimension_filters: queryDimensionFilters },
      } = body;

      const areDimensionsEqual = isEqual(
        queryDimensionNames,
        mutationDimensionNames,
      );
      const areDimensionFiltersEqual = isEqual(
        queryDimensionFilters,
        mutationDimensionFilters,
      );

      return !areDimensionsEqual || !areDimensionFiltersEqual;
    });
  }

  // if the selection is not an include list, invalidate all cache entries
  return inSeasonCachedQueryArgs;
};
